const postTheError = function(payload) {
    window.axios.post('/api/js-errors', payload)
        .then(response => {
            console.log(response.data);
        })
}

export default function (msg, src, lineNo, colNo, error) {
    let payload = {
        'name': (error !== null && typeof error != 'undefined') ? error.name : 'unknown',
        'message': msg,
        'source': src,
        'line_number': lineNo,
        'column_number': colNo,
        user_agent: navigator.userAgent,
    };
        
    if (error || error.stack) {
        payload.stacktrace = error.stack
    }

    postTheError(payload);
    return false;
}
